module.exports = __webpack_public_path__ + "img/2.ecaef40a.jpg";